import { useEffect, useState } from 'react';
import { getPublicPage } from '../../lib/api';
import type { CustomPage } from '../../lib/types';
import { BookingCta } from '../components/BookingCta';
import { NotFoundPage } from './NotFoundPage';

export function CustomPageView({ page }: { page: CustomPage }) {
  return <><header className="page-hero"><p className="eyebrow">Christina J Barea</p><h1>{page.title}</h1>{page.summary && <p className="page-hero__lead">{page.summary}</p>}</header><section className="custom-page">{page.blocks.map((block) => {
    if (block.type === 'heading') return block.level === 3 ? <h3 key={block.id}>{block.text}</h3> : <h2 key={block.id}>{block.text}</h2>;
    if (block.type === 'paragraph') return <p key={block.id}>{block.text}</p>;
    if (block.type === 'quote') return <figure key={block.id}><blockquote>“{block.text}”</blockquote><figcaption>{block.attribution}</figcaption></figure>;
    if (block.type === 'image') return <figure key={block.id}><img src={`/api/public/media/${encodeURIComponent(block.mediaId)}/content`} alt={block.altText} /><figcaption>{block.caption}</figcaption></figure>;
    return <aside className="custom-callout" key={block.id}><h2>{block.title}</h2><p>{block.text}</p>{block.linkUrl && <a className="button" href={block.linkUrl}>{block.linkLabel}</a>}</aside>;
  })}</section><BookingCta /></>;
}

export function CustomPageRoute({ slug }: { slug: string }) {
  const [page, setPage] = useState<CustomPage | null | undefined>(undefined);
  useEffect(() => { getPublicPage(slug).then(setPage).catch(() => setPage(null)); }, [slug]);
  if (page === undefined) {
    const provisionalTitle = slug.split('-').filter(Boolean).map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(' ');
    return <section className="not-found" aria-label="Loading page"><h1>{provisionalTitle}</h1><p>Loading…</p></section>;
  }
  return page ? <CustomPageView page={page} /> : <NotFoundPage />;
}
